import { useContext } from "react";
import Reel from "../../../../components/main/reel/Reel";
import { MainContext } from "../../Main";

import "./AzureTower.scss";
import { azureTowerStops } from "./stops";

export default function AzureTower() {
    const [changeContent, setModalContent] = useContext(MainContext);

    return (
        <div className="azure-tower" style={{ width: "100%", height: "100%" }}>
            <Reel
                folder="static/images/contents/azure-tower/renders"
                amount={120}
                qualitySteps={4}
                defaultControlsPart={0.075}
                stops={azureTowerStops(changeContent)}
                overlay_elements={null} // Soon
            />
        </div>
    );
}
